import { useState } from 'react';

import { DateSlots } from '../../contexts/checkout';

const useWeeklyChosenState = (
  dateSlotsPerWeek: { [k: string]: DateSlots },
  initialState: Record<string, string[]>
) => {
  const [chosenWeekDaytimes, setChosenWeekDaytimes] =
    useState<Record<string, string[]>>(initialState);

  const onWeekRemove = (
    weekIdToRemove: string,
    onEmptyChosenList?: () => void
  ) => {
    const filteredEntries = Object.entries(chosenWeekDaytimes).filter(
      ([weekId]) => weekId !== weekIdToRemove
    );
    setChosenWeekDaytimes(Object.fromEntries(filteredEntries));
    if (filteredEntries.length === 0) {
      onEmptyChosenList?.();
    }
  };

  const onWeekSelect = (weekId: string, daytimes: string[]) => {
    if (!dateSlotsPerWeek[weekId]) {
      throw new Error(
        `could not get dateslots with weekId:${weekId}. this should not happen`
      );
    }

    setChosenWeekDaytimes({
      ...chosenWeekDaytimes,
      [weekId]: daytimes,
    });
  };

  return {
    chosenWeekDaytimes,
    onWeekSelect,
    onWeekRemove,
    overwriteChosenWeekDaytimes: setChosenWeekDaytimes,
  };
};

export default useWeeklyChosenState;
